// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2B8Pt","detailsBorder":"styles_detailsBorder__2fAl8"};